import axios from "axios";

export const BACKEND = process.env.REACT_APP_BACKEND_URL || "";
export const api = axios.create({ baseURL: `${BACKEND}/api`, withCredentials: true });

let token = localStorage.getItem("mp_token");
export const setToken = (t) => {
  token = t;
  if (t) localStorage.setItem("mp_token", t);
  else localStorage.removeItem("mp_token");
};

api.interceptors.request.use((cfg) => {
  if (token) cfg.headers.Authorization = `Bearer ${token}`;
  return cfg;
});

api.interceptors.response.use(
  (r) => r,
  async (err) => {
    const cfg = err.config || {};
    const url = cfg.url || "";
    if (err.response?.status === 401 && !cfg._retry && !url.includes("/auth/")) {
      cfg._retry = true;
      try {
        const { data } = await api.post("/auth/refresh");
        setToken(data?.token);
        return api(cfg);
      } catch {
        setToken(null);
      }
    }
    return Promise.reject(err);
  }
);

export const img = (src) => {
  if (!src) return "/img/brand.jpg";
  return src.startsWith("/api/") ? `${BACKEND}${src}` : src;
};

export const money = (n) => `$${Number(n || 0).toLocaleString("en-CA")}`;

export const fmtErr = (e) => {
  const d = e?.response?.data?.detail;
  if (d == null) return e?.message || "Something went wrong. Please try again.";
  if (typeof d === "string") return d;
  if (Array.isArray(d)) return d.map((x) => x?.msg || JSON.stringify(x)).join(" ");
  return d?.msg || String(d);
};

export const list = (res) => (Array.isArray(res?.data) ? res.data : []);
